import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import {PermissionService} from "./permission.service";

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  readonly forbiddenPath = '/forbidden/index.html';

  constructor(private permissionService: PermissionService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const { requiredPermissions } = route.data;
    const hasPermissions = this.permissionService.hasPermission(requiredPermissions);
    if (!hasPermissions) {
      document.location.href = document.location.origin + this.forbiddenPath;
      return false;
    } else {
      return true;
    }
  }
}
